/**
 * @file   src\components\Inventory\EditInventory\InventoryPropertyDetails.js
 * @brief  This file is responsible for the view of inventory property Description section.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useEffect, useState } from "react";
import { FormLabel } from "react-bootstrap";
import TextArea from "../../Common/TextArea";
import { handleTextBoxChange } from "../../../actions/common";
import { checkIsNull } from "../../../helpers/common";
import { ERROR_TEXT } from "../../../constants/common";

const InventoryPropertyDetails = (props) => {
  const { handleFormValues, invtryDetails, descriptionError } = props;

  // Initialize component state variables and constants.
  const [detailCharCount, setDetailCharCount] = useState(0);
  const [descError, setDescError] = useState("");

  // invtryDetails, descError state change side effect handling.
  useEffect(() => {
    setDetailCharCount(
      invtryDetails && invtryDetails.length ? invtryDetails.length : 0
    );
  }, [invtryDetails, descError]);

  // To capitalize the first letter of the string
  const capitalizeFirstString = (str) => {
    return str && str.charAt(0).toUpperCase() + str.slice(1);
  };

  // description change event handler
  const handleDetailsChange = (e) => {
    const value = capitalizeFirstString(handleTextBoxChange(e));
    if (!checkIsNull(value)) {
      handleFormValues({ invtryDetails: value });
      setDetailCharCount(value.length);
    } else {
      handleFormValues({ invtryDetails: "" });
    }
  };

  return (
    <>
      <div className="wantad-des-wrap">
        <div className="position-relative">
          <FormLabel className={descriptionError && "red-marked-label"}>
            Additional details
          </FormLabel>
          <TextArea
            className={
              descriptionError
                ? "form-control txt-area red-marked-formcontrol"
                : "form-control txt-area"
            }
            errorMessage={descriptionError ? ERROR_TEXT : null}
            maxLength={2500}
            value={invtryDetails ? invtryDetails : ""}
            placeholder="Tell us more about this property…"
            onChange={(e) => {
              handleDetailsChange(e);
            }}
          />

          <div
            className={
              descriptionError
                ? "des-count red-marked-des-count mb-4"
                : "des-count  mb-4"
            }
          >
            <span>{detailCharCount}</span>/<span>2500</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default InventoryPropertyDetails;
